export const getGLAccounts = (state) => state.GLAccounts;